import { render, staticRenderFns } from "./btnBackTop.vue?vue&type=template&id=caa1be92&scoped=true&"
import script from "./btnBackTop.vue?vue&type=script&lang=js&"
export * from "./btnBackTop.vue?vue&type=script&lang=js&"
import style0 from "./btnBackTop.vue?vue&type=style&index=0&id=caa1be92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa1be92",
  null
  
)

export default component.exports